import React, { useRef, useState, useEffect } from 'react';
import { useParallax } from '../hooks/useParallax';
import '../styles/Hero.css';

function Hero() {
  const sectionRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const images = [
    '/assest/images/hero-1.jpeg',
    '/assest/images/hero-2.jpeg',
    '/assest/images/hero-3.jpeg',
    '/assest/images/hero-4.jpeg'
  ];

  useParallax(sectionRef, 0.22);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 80);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [images.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const goToPrevious = () => {
    setCurrentSlide((prev) => (prev - 1 + images.length) % images.length);
  };

  const goToNext = () => {
    setCurrentSlide((prev) => (prev + 1) % images.length);
  };

  return (
    <div ref={sectionRef} className={`hero-section parallax-layer ${loaded ? 'hero-loaded' : ''}`}>
      <div className="hero-slider">
        {images.map((image, index) => (
          <div
            key={image}
            className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
          >
            <div
              className="hero-slide-bg"
              style={{ backgroundImage: `url(${image})` }}
            />
            <div className="hero-overlay" />
          </div>
        ))}
      </div>

      <button className="hero-nav hero-nav-prev" onClick={goToPrevious} aria-label="Previous slide">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="15 18 9 12 15 6" />
        </svg>
      </button>
      <button className="hero-nav hero-nav-next" onClick={goToNext} aria-label="Next slide">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="9 18 15 12 9 6" />
        </svg>
      </button>

      <div className="hero-indicators">
        {images.map((image, index) => (
          <button
            key={image}
            className={`hero-indicator ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>

      <div className="hero-scroll-hint" aria-hidden>
        <span>Scroll</span>
        <div className="hero-scroll-line" />
      </div>
    </div>
  );
}

export default Hero;
